import RightSupport from './RightSupportIcon';
export default RightSupport;